module.exports = __webpack_public_path__ + "static/media/print-3.39252533.jpg";